import { ButtonColor } from '@freelancer/ui/button';

export enum CardLevel {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}

export enum CardSize {
  SMALL = 'small',
  MID = 'mid',
}

export enum CardBorderRadius {
  MID = 'mid',
  LARGE = 'large',
}

export enum FlexAlignItems {
  FLEX_START = 'flex-start',
  FLEX_END = 'flex-end',
  CENTER = 'center',
  BASELINE = 'baseline',
  STRETCH = 'stretch',
}

export enum FlexDirection {
  COLUMN = 'column',
  ROW = 'row',
}

export enum FlexJustifyContent {
  FLEX_START = 'flex-start',
  FLEX_END = 'flex-end',
  CENTER = 'center',
  SPACE_BETWEEN = 'space-between',
  SPACE_AROUND = 'space-around',
  SPACE_EVENLY = 'space-evenly',
}

export interface CardHeaderButton {
  text: string;
  color?: ButtonColor;
  link?: string;
  fragment?: string;
  queryParams?: { [k: string]: any };
  linkActive?: string[] | string;
  linkActiveOptions?: { exact: boolean };
  busy?: boolean;
}
